// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phpay-login-shell {
  position: fixed;
  inset: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: minmax(360px, 44%) minmax(0, 1fr);
  min-height: 100dvh;
  overflow: hidden;
  background: #f7faf8;
  color: #191f28;
}

.phpay-login-hero {
  min-width: 0;
  background:
    radial-gradient(circle at 16% 18%, rgba(255, 255, 255, 0.94) 0, rgba(255, 255, 255, 0) 32%),
    radial-gradient(circle at 88% 78%, rgba(126, 211, 159, 0.32) 0, rgba(126, 211, 159, 0) 36%),
    linear-gradient(145deg, #f3fbf6 0%, #e1f5e8 52%, #ccebd8 100%);
  color: #143322;
  border-right: 1px solid rgba(7, 105, 49, 0.1);
}

.phpay-login-hero__inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: clamp(36px, 5vw, 72px);
  box-sizing: border-box;
}

.phpay-login-logo-box {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 54px;
  padding: 8px 16px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(7, 105, 49, 0.08);
  box-shadow: 0 14px 36px rgba(30, 91, 56, 0.11);
}

.phpay-login-logo {
  display: block;
  max-width: 180px;
  object-fit: contain;
}

.phpay-login-hero__copy {
  margin: auto 0;
}

.phpay-login-hero__eyebrow {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 20px;
  padding: 0 11px;
  border: 1px solid rgba(7, 105, 49, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.62);
  color: var(--brand-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.phpay-login-hero h1 {
  margin: 0;
  color: #153c27;
  font-size: clamp(38px, 4vw, 60px);
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: -0.045em;
}

.phpay-login-hero__copy p {
  max-width: 420px;
  margin: 24px 0 0;
  color: #537061;
  font-size: 16px;
  line-height: 1.7;
}

.phpay-login-hero__status {
  display: flex;
  align-items: center;
  gap: 9px;
  width: fit-content;
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid rgba(7, 105, 49, 0.1);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.62);
  color: #466755;
  font-size: 13px;
  font-weight: 600;
}

.phpay-login-form-pane {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  padding: 48px;
  overflow-y: auto;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 88% 12%, rgba(218, 242, 227, 0.66) 0, rgba(218, 242, 227, 0) 26%),
    linear-gradient(180deg, #fbfdfc 0%, #f5f9f6 100%);
}

.phpay-login-form-panel {
  width: min(100%, 420px);
  padding: 38px;
  border: 1px solid #e4ece7;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 64px rgba(37, 69, 50, 0.1);
  box-sizing: border-box;
}

.phpay-login-portal-label {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 11px;
  border-radius: 999px;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.phpay-login-form-panel h2 {
  margin: 22px 0 8px;
  color: #191f28;
  font-size: 34px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.035em;
}

.phpay-login-form-description {
  margin: 0 0 36px;
  color: #6b7684;
  font-size: 15px;
  line-height: 1.6;
}

.phpay-login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.phpay-login-field label {
  display: block;
  margin-bottom: 8px;
  color: #333d4b;
  font-size: 14px;
  font-weight: 700;
}

.phpay-login-input-wrap {
  position: relative;
}

.phpay-login-field input[type='text'],
.phpay-login-field input[type='password'] {
  width: 100%;
  height: 54px;
  padding: 0 16px;
  border: 1px solid #d9e0dc;
  border-radius: 12px;
  background: #fff;
  color: #191f28;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.phpay-login-field input::placeholder {
  color: #9ca8a1;
}

.phpay-login-field input:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 4px var(--brand-focus-ring);
}

.phpay-login-input-wrap input {
  padding-right: 48px !important;
}

.phpay-login-password-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #7b887f;
  cursor: pointer;
}

.phpay-login-password-toggle:hover {
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
}

.phpay-login-primary-button,
.phpay-login-secondary-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 800;
  text-decoration: none;
  box-sizing: border-box;
  transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.phpay-login-primary-button {
  border: 1px solid var(--brand-primary);
  background: var(--brand-primary);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(var(--brand-primary-rgb), 0.2);
}

.phpay-login-primary-button:hover:not(:disabled) {
  border-color: var(--brand-primary-hover);
  background: var(--brand-primary-hover);
}

.phpay-login-primary-button:active:not(:disabled) {
  transform: translateY(1px);
  border-color: var(--brand-primary-active);
  background: var(--brand-primary-active);
}

.phpay-login-primary-button:disabled {
  border-color: var(--brand-primary-disabled);
  background: var(--brand-primary-disabled);
  cursor: not-allowed;
  box-shadow: none;
}

.phpay-login-secondary-button {
  border: 1px solid var(--brand-primary-border);
  background: #fff;
  color: var(--brand-primary);
}

.phpay-login-secondary-button:hover {
  border-color: var(--brand-primary);
  background: var(--brand-primary-soft);
}

.phpay-login-mall-button {
  border-color: transparent;
  background: var(--brand-primary-soft);
  color: var(--brand-primary);
  font-weight: 500;
}

.phpay-login-mall-button:hover {
  border-color: var(--brand-primary-border);
  background: var(--brand-primary-soft-strong);
}

.phpay-login-save-id {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: -2px;
  color: #59645d;
  font-size: 14px;
}

.phpay-login-save-id input {
  width: 18px;
  height: 18px;
  margin: 0;
  accent-color: var(--brand-primary);
}

.phpay-login-copyright {
  margin: 36px 0 0;
  color: #8b958f;
  font-size: 12px;
  line-height: 1.5;
}

.phpay-login-toast {
  position: fixed;
  top: 18px;
  left: 50%;
  z-index: 3000;
  width: calc(100% - 32px);
  max-width: 420px;
  padding: 13px 16px;
  border: 1px solid #ffd7d7;
  border-radius: 12px;
  background: #fff;
  color: #9b1c1c;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 12px 32px rgba(25, 31, 40, 0.14);
  transform: translateX(-50%);
  box-sizing: border-box;
}

.phpay-login-shell--app {
  left: 50%;
  width: min(100%, 768px);
  grid-template-columns: 1fr;
  grid-template-rows: 104px minmax(0, 1fr);
  background: #fff;
  transform: translateX(-50%);
}

.phpay-login-shell--app .phpay-login-hero {
  background: #fff;
  color: #191f28;
}

.phpay-login-shell--app .phpay-login-hero__inner {
  padding: 28px 24px 10px;
}

.phpay-login-shell--app .phpay-login-logo-box {
  min-height: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.phpay-login-shell--app .phpay-login-logo {
  max-width: 112px;
  max-height: 38px;
}

.phpay-login-shell--app .phpay-login-hero__copy {
  display: none;
}

.phpay-login-shell--app .phpay-login-hero__eyebrow,
.phpay-login-shell--app .phpay-login-hero__status {
  display: none;
}

.phpay-login-shell--app .phpay-login-form-pane {
  align-items: center;
  padding: 0;
  overflow-y: auto;
  background: #fff;
}

.phpay-login-shell--app .phpay-login-form-panel {
  width: 100%;
  max-width: 480px;
  min-height: 0;
  margin-top: 0;
  padding: 12px 24px 94px;
  border-radius: 0;
  border: 0;
  background: #fff;
  box-shadow: none;
  box-sizing: border-box;
}

.phpay-login-shell--app .phpay-login-portal-label {
  display: none;
}

.phpay-login-shell--app .phpay-login-form-panel h2 {
  margin: 0 0 8px;
  color: #191f28;
  font-size: 30px;
  line-height: 1.3;
}

.phpay-login-shell--app .phpay-login-form-description {
  margin-bottom: 34px;
  color: #6b7684;
  font-size: 15px;
}

.phpay-login-shell--app .phpay-login-form {
  gap: 18px;
}

.phpay-login-shell--app .phpay-login-field label {
  margin-bottom: 9px;
  color: #4e5968;
  font-size: 14px;
  font-weight: 600;
}

.phpay-login-shell--app .phpay-login-field input[type='text'],
.phpay-login-shell--app .phpay-login-field input[type='password'] {
  height: 56px;
  border-color: transparent;
  border-radius: 14px;
  background: #f2f4f6;
}

.phpay-login-shell--app .phpay-login-field input[type='text']:focus,
.phpay-login-shell--app .phpay-login-field input[type='password']:focus {
  border-color: var(--brand-primary);
  background: #fff;
}

.phpay-login-shell--app .phpay-login-password-toggle {
  top: 0;
  right: 6px;
  bottom: 0;
  width: 44px;
  height: 56px;
  margin: auto 0;
  transform: none;
  color: #8b95a1;
}

.phpay-login-shell--app .phpay-login-password-toggle svg {
  display: block;
}

.phpay-login-shell--app .phpay-login-primary-button {
  height: 56px;
  border-radius: 14px;
  box-shadow: none;
}

.phpay-login-shell--app .phpay-login-mall-button {
  height: 56px;
  border-radius: 14px;
}

.phpay-login-shell--app .phpay-login-save-id {
  color: #6b7684;
}

.phpay-login-shell--app .phpay-login-copyright {
  margin-top: 28px;
  padding-bottom: 76px;
  color: #adb5bd;
  text-align: center;
}

@media (max-height: 760px) {
  .phpay-login-shell--app {
    grid-template-rows: 82px minmax(0, 1fr);
  }

  .phpay-login-shell--app .phpay-login-hero__inner {
    padding-top: 20px;
    padding-bottom: 6px;
  }

  .phpay-login-shell--app .phpay-login-form-panel {
    padding: 28px 24px 86px;
  }

  .phpay-login-shell--app .phpay-login-form-pane {
    align-items: flex-start;
  }

  .phpay-login-shell--app .phpay-login-copyright {
    margin-top: 18px;
  }
}

@media (max-width: 820px) {
  .phpay-login-shell--desktop {
    grid-template-columns: 1fr;
    grid-template-rows: minmax(190px, 30dvh) minmax(0, 1fr);
    overflow-y: auto;
  }

  .phpay-login-shell--desktop .phpay-login-hero__inner {
    padding: 24px 28px 42px;
  }

  .phpay-login-shell--desktop .phpay-login-logo-box {
    min-height: 42px;
    padding: 6px 12px;
    border-radius: 10px;
  }

  .phpay-login-shell--desktop .phpay-login-logo {
    max-width: 130px;
    max-height: 42px;
  }

  .phpay-login-shell--desktop .phpay-login-hero__copy {
    margin: auto 0 0;
  }

  .phpay-login-shell--desktop .phpay-login-hero__eyebrow,
  .phpay-login-shell--desktop .phpay-login-hero__status,
  .phpay-login-shell--desktop .phpay-login-hero__copy p {
    display: none;
  }

  .phpay-login-shell--desktop .phpay-login-hero h1 {
    font-size: 30px;
  }

  .phpay-login-shell--desktop .phpay-login-form-pane {
    align-items: flex-start;
    padding: 30px 24px 40px;
    background: #fff;
  }

  .phpay-login-shell--desktop .phpay-login-form-panel {
    width: min(100%, 480px);
    margin: 0 auto;
    padding: 0;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .phpay-login-form-panel h2 {
    font-size: 29px;
  }

  .phpay-login-form-description {
    margin-bottom: 28px;
  }
}

@media (max-height: 720px) and (min-width: 821px) {
  .phpay-login-hero__inner {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .phpay-login-hero__copy p {
    margin-top: 14px;
  }

  .phpay-login-form-pane {
    align-items: flex-start;
    padding-top: 32px;
    padding-bottom: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Common/components/Login/PhpPayLoginShell.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ;;;kEAGgE;EAChE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB;;qDAEmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,sFAAsF;AACxF;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,uCAAuC;EACzC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,uDAAuD;IACvD,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":[".phpay-login-shell {\n  position: fixed;\n  inset: 0;\n  z-index: 10;\n  display: grid;\n  grid-template-columns: minmax(360px, 44%) minmax(0, 1fr);\n  min-height: 100dvh;\n  overflow: hidden;\n  background: #f7faf8;\n  color: #191f28;\n}\n\n.phpay-login-hero {\n  min-width: 0;\n  background:\n    radial-gradient(circle at 16% 18%, rgba(255, 255, 255, 0.94) 0, rgba(255, 255, 255, 0) 32%),\n    radial-gradient(circle at 88% 78%, rgba(126, 211, 159, 0.32) 0, rgba(126, 211, 159, 0) 36%),\n    linear-gradient(145deg, #f3fbf6 0%, #e1f5e8 52%, #ccebd8 100%);\n  color: #143322;\n  border-right: 1px solid rgba(7, 105, 49, 0.1);\n}\n\n.phpay-login-hero__inner {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: clamp(36px, 5vw, 72px);\n  box-sizing: border-box;\n}\n\n.phpay-login-logo-box {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  min-height: 54px;\n  padding: 8px 16px;\n  border-radius: 14px;\n  background: #fff;\n  border: 1px solid rgba(7, 105, 49, 0.08);\n  box-shadow: 0 14px 36px rgba(30, 91, 56, 0.11);\n}\n\n.phpay-login-logo {\n  display: block;\n  max-width: 180px;\n  object-fit: contain;\n}\n\n.phpay-login-hero__copy {\n  margin: auto 0;\n}\n\n.phpay-login-hero__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  margin-bottom: 20px;\n  padding: 0 11px;\n  border: 1px solid rgba(7, 105, 49, 0.12);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.62);\n  color: var(--brand-primary);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n}\n\n.phpay-login-hero h1 {\n  margin: 0;\n  color: #153c27;\n  font-size: clamp(38px, 4vw, 60px);\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: -0.045em;\n}\n\n.phpay-login-hero__copy p {\n  max-width: 420px;\n  margin: 24px 0 0;\n  color: #537061;\n  font-size: 16px;\n  line-height: 1.7;\n}\n\n.phpay-login-hero__status {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  width: fit-content;\n  min-height: 38px;\n  padding: 0 14px;\n  border: 1px solid rgba(7, 105, 49, 0.1);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.62);\n  color: #466755;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.phpay-login-form-pane {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  padding: 48px;\n  overflow-y: auto;\n  box-sizing: border-box;\n  background:\n    radial-gradient(circle at 88% 12%, rgba(218, 242, 227, 0.66) 0, rgba(218, 242, 227, 0) 26%),\n    linear-gradient(180deg, #fbfdfc 0%, #f5f9f6 100%);\n}\n\n.phpay-login-form-panel {\n  width: min(100%, 420px);\n  padding: 38px;\n  border: 1px solid #e4ece7;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 24px 64px rgba(37, 69, 50, 0.1);\n  box-sizing: border-box;\n}\n\n.phpay-login-portal-label {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 11px;\n  border-radius: 999px;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.phpay-login-form-panel h2 {\n  margin: 22px 0 8px;\n  color: #191f28;\n  font-size: 34px;\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: -0.035em;\n}\n\n.phpay-login-form-description {\n  margin: 0 0 36px;\n  color: #6b7684;\n  font-size: 15px;\n  line-height: 1.6;\n}\n\n.phpay-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.phpay-login-field label {\n  display: block;\n  margin-bottom: 8px;\n  color: #333d4b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.phpay-login-input-wrap {\n  position: relative;\n}\n\n.phpay-login-field input[type='text'],\n.phpay-login-field input[type='password'] {\n  width: 100%;\n  height: 54px;\n  padding: 0 16px;\n  border: 1px solid #d9e0dc;\n  border-radius: 12px;\n  background: #fff;\n  color: #191f28;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.phpay-login-field input::placeholder {\n  color: #9ca8a1;\n}\n\n.phpay-login-field input:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 4px var(--brand-focus-ring);\n}\n\n.phpay-login-input-wrap input {\n  padding-right: 48px !important;\n}\n\n.phpay-login-password-toggle {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #7b887f;\n  cursor: pointer;\n}\n\n.phpay-login-password-toggle:hover {\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n}\n\n.phpay-login-primary-button,\n.phpay-login-secondary-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 54px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 800;\n  text-decoration: none;\n  box-sizing: border-box;\n  transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n}\n\n.phpay-login-primary-button {\n  border: 1px solid var(--brand-primary);\n  background: var(--brand-primary);\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 10px 24px rgba(var(--brand-primary-rgb), 0.2);\n}\n\n.phpay-login-primary-button:hover:not(:disabled) {\n  border-color: var(--brand-primary-hover);\n  background: var(--brand-primary-hover);\n}\n\n.phpay-login-primary-button:active:not(:disabled) {\n  transform: translateY(1px);\n  border-color: var(--brand-primary-active);\n  background: var(--brand-primary-active);\n}\n\n.phpay-login-primary-button:disabled {\n  border-color: var(--brand-primary-disabled);\n  background: var(--brand-primary-disabled);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.phpay-login-secondary-button {\n  border: 1px solid var(--brand-primary-border);\n  background: #fff;\n  color: var(--brand-primary);\n}\n\n.phpay-login-secondary-button:hover {\n  border-color: var(--brand-primary);\n  background: var(--brand-primary-soft);\n}\n\n.phpay-login-mall-button {\n  border-color: transparent;\n  background: var(--brand-primary-soft);\n  color: var(--brand-primary);\n  font-weight: 500;\n}\n\n.phpay-login-mall-button:hover {\n  border-color: var(--brand-primary-border);\n  background: var(--brand-primary-soft-strong);\n}\n\n.phpay-login-save-id {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: -2px;\n  color: #59645d;\n  font-size: 14px;\n}\n\n.phpay-login-save-id input {\n  width: 18px;\n  height: 18px;\n  margin: 0;\n  accent-color: var(--brand-primary);\n}\n\n.phpay-login-copyright {\n  margin: 36px 0 0;\n  color: #8b958f;\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.phpay-login-toast {\n  position: fixed;\n  top: 18px;\n  left: 50%;\n  z-index: 3000;\n  width: calc(100% - 32px);\n  max-width: 420px;\n  padding: 13px 16px;\n  border: 1px solid #ffd7d7;\n  border-radius: 12px;\n  background: #fff;\n  color: #9b1c1c;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  box-shadow: 0 12px 32px rgba(25, 31, 40, 0.14);\n  transform: translateX(-50%);\n  box-sizing: border-box;\n}\n\n.phpay-login-shell--app {\n  left: 50%;\n  width: min(100%, 768px);\n  grid-template-columns: 1fr;\n  grid-template-rows: 104px minmax(0, 1fr);\n  background: #fff;\n  transform: translateX(-50%);\n}\n\n.phpay-login-shell--app .phpay-login-hero {\n  background: #fff;\n  color: #191f28;\n}\n\n.phpay-login-shell--app .phpay-login-hero__inner {\n  padding: 28px 24px 10px;\n}\n\n.phpay-login-shell--app .phpay-login-logo-box {\n  min-height: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.phpay-login-shell--app .phpay-login-logo {\n  max-width: 112px;\n  max-height: 38px;\n}\n\n.phpay-login-shell--app .phpay-login-hero__copy {\n  display: none;\n}\n\n.phpay-login-shell--app .phpay-login-hero__eyebrow,\n.phpay-login-shell--app .phpay-login-hero__status {\n  display: none;\n}\n\n.phpay-login-shell--app .phpay-login-form-pane {\n  align-items: center;\n  padding: 0;\n  overflow-y: auto;\n  background: #fff;\n}\n\n.phpay-login-shell--app .phpay-login-form-panel {\n  width: 100%;\n  max-width: 480px;\n  min-height: 0;\n  margin-top: 0;\n  padding: 12px 24px 94px;\n  border-radius: 0;\n  border: 0;\n  background: #fff;\n  box-shadow: none;\n  box-sizing: border-box;\n}\n\n.phpay-login-shell--app .phpay-login-portal-label {\n  display: none;\n}\n\n.phpay-login-shell--app .phpay-login-form-panel h2 {\n  margin: 0 0 8px;\n  color: #191f28;\n  font-size: 30px;\n  line-height: 1.3;\n}\n\n.phpay-login-shell--app .phpay-login-form-description {\n  margin-bottom: 34px;\n  color: #6b7684;\n  font-size: 15px;\n}\n\n.phpay-login-shell--app .phpay-login-form {\n  gap: 18px;\n}\n\n.phpay-login-shell--app .phpay-login-field label {\n  margin-bottom: 9px;\n  color: #4e5968;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.phpay-login-shell--app .phpay-login-field input[type='text'],\n.phpay-login-shell--app .phpay-login-field input[type='password'] {\n  height: 56px;\n  border-color: transparent;\n  border-radius: 14px;\n  background: #f2f4f6;\n}\n\n.phpay-login-shell--app .phpay-login-field input[type='text']:focus,\n.phpay-login-shell--app .phpay-login-field input[type='password']:focus {\n  border-color: var(--brand-primary);\n  background: #fff;\n}\n\n.phpay-login-shell--app .phpay-login-password-toggle {\n  top: 0;\n  right: 6px;\n  bottom: 0;\n  width: 44px;\n  height: 56px;\n  margin: auto 0;\n  transform: none;\n  color: #8b95a1;\n}\n\n.phpay-login-shell--app .phpay-login-password-toggle svg {\n  display: block;\n}\n\n.phpay-login-shell--app .phpay-login-primary-button {\n  height: 56px;\n  border-radius: 14px;\n  box-shadow: none;\n}\n\n.phpay-login-shell--app .phpay-login-mall-button {\n  height: 56px;\n  border-radius: 14px;\n}\n\n.phpay-login-shell--app .phpay-login-save-id {\n  color: #6b7684;\n}\n\n.phpay-login-shell--app .phpay-login-copyright {\n  margin-top: 28px;\n  padding-bottom: 76px;\n  color: #adb5bd;\n  text-align: center;\n}\n\n@media (max-height: 760px) {\n  .phpay-login-shell--app {\n    grid-template-rows: 82px minmax(0, 1fr);\n  }\n\n  .phpay-login-shell--app .phpay-login-hero__inner {\n    padding-top: 20px;\n    padding-bottom: 6px;\n  }\n\n  .phpay-login-shell--app .phpay-login-form-panel {\n    padding: 28px 24px 86px;\n  }\n\n  .phpay-login-shell--app .phpay-login-form-pane {\n    align-items: flex-start;\n  }\n\n  .phpay-login-shell--app .phpay-login-copyright {\n    margin-top: 18px;\n  }\n}\n\n@media (max-width: 820px) {\n  .phpay-login-shell--desktop {\n    grid-template-columns: 1fr;\n    grid-template-rows: minmax(190px, 30dvh) minmax(0, 1fr);\n    overflow-y: auto;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-hero__inner {\n    padding: 24px 28px 42px;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-logo-box {\n    min-height: 42px;\n    padding: 6px 12px;\n    border-radius: 10px;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-logo {\n    max-width: 130px;\n    max-height: 42px;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-hero__copy {\n    margin: auto 0 0;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-hero__eyebrow,\n  .phpay-login-shell--desktop .phpay-login-hero__status,\n  .phpay-login-shell--desktop .phpay-login-hero__copy p {\n    display: none;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-hero h1 {\n    font-size: 30px;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-form-pane {\n    align-items: flex-start;\n    padding: 30px 24px 40px;\n    background: #fff;\n  }\n\n  .phpay-login-shell--desktop .phpay-login-form-panel {\n    width: min(100%, 480px);\n    margin: 0 auto;\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .phpay-login-form-panel h2 {\n    font-size: 29px;\n  }\n\n  .phpay-login-form-description {\n    margin-bottom: 28px;\n  }\n}\n\n@media (max-height: 720px) and (min-width: 821px) {\n  .phpay-login-hero__inner {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  .phpay-login-hero__copy p {\n    margin-top: 14px;\n  }\n\n  .phpay-login-form-pane {\n    align-items: flex-start;\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
